import { render } from "./subscriptionList.vue?vue&type=template&id=20d171dc&scoped=true"
import script from "./subscriptionList.vue?vue&type=script&lang=js"
export * from "./subscriptionList.vue?vue&type=script&lang=js"

import "./subscriptionList.vue?vue&type=style&index=0&id=20d171dc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d171dc"]])

export default __exports__